module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/AuthorNote"
    }
  }, [_vm._v("A Note From The Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartOne"
    }
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Prologue"
    }
  }, [_vm._v("Prologue - The Reporter")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_01"
    }
  }, [_vm._v("Chapter 1 - Infamous")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_02"
    }
  }, [_vm._v("Chapter 2 - Out of the Ashes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_03"
    }
  }, [_vm._v("Chapter 3 - Homeless Steve")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 -The Experiments")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 - The One-Eyed Man")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 - Connecting the Dots")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 - Rogue Messiah")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 - Starfished")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 - The Sound of Silence")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 - The Fog Man")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartTwo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 - Norris")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 -The Regulator")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 - Highwayman’s Second Wave")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 – Road Trip")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 - Escape")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 - Run for the River")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 – The Fug Game")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 – Maxwell")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19 – Gifts")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 – Hot Brown")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartThree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21 – Dick 101")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22 – Into the Third Room")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23 – Car Trouble")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24 – Beating the Bushes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25 – Cat Food Man")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26 – Devil’s Workshop")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27 – Lawyer Bob")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28 – MacDonald Triad")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29 – Three Acts")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0